import React, { useState, useEffect } from 'react'
import StoryblokClient from 'storyblok-js-client'
import Layout from '../modules/Layout'
import BodyBlocks from '../technical/BodyBlocks'
import HeroBlock from '../blocks/HeroBlock'
import ProductIntroBlock from '../blocks/ProductIntroBlock'
import PconUiToolBlock from '../blocks/PconUiToolBlock'
import DownloadsBlock from '../blocks/DownloadsBlock'
import RelatedProductsBlock from '../blocks/RelatedProductsBlock'

import { useTranslation } from 'react-i18next'
import SEO from '../modules/Seo'

const ProductPage = ({ content, locale, name, alternates }) => {
  const [similarProducts, setSimilarProducts] = useState([])
  const { t } = useTranslation()

  const Storyblok = new StoryblokClient({
    accessToken: process.env.GATSBY_STORYBLOK_ACCESS_TOKEN,
    cache: {
      clear: 'auto',
      type: 'memory',
    },
  })

  const getRelatedProducts = async () => {
    let relatedProducts = []
    await Promise.all(
      content.similar_products.map(async (product) => {
        const response = await Storyblok.get(`cdn/stories/${product}`, {
          version: 'published',
        })
        relatedProducts.push(response.data.story)
      })
    ).then(() => {
      // console.log(relatedProducts)
      setSimilarProducts(relatedProducts)
    })
  }

  useEffect(() => {
    getRelatedProducts()

    return () => {
      setSimilarProducts([])
    }
  }, [])

  var metaNavItems = []

  if (content && content.body) {
    content.body.forEach((block) => {
      if (block.component == 'product_gallery_block') {
        metaNavItems.push({
          title: t('product_page.product_gallery_block.nav_title'),
          url: '#' + block._uid,
        })
      }
      if (block.component == 'pinpoint_block') {
        metaNavItems.push({
          title: t('product_page.pinpoint_block.nav_title'),
          url: '#' + block._uid,
        })
      }
      if (block.component == 'image_slider_block') {
        metaNavItems.push({
          title: t('product_page.image_slider_block.nav_title'),
          url: '#' + block._uid,
        })
      }
      if (block.component == 'video_block') {
        metaNavItems.push({
          title: t('product_page.video_block.nav_title'),
          url: '#' + block._uid,
        })
      }
      if (block.component == 'static_downloads_block') {
        metaNavItems.push({
          title: t('product_page.downloads_block.nav_title'),
          url: '#' + block._uid,
        })
      }
    })
    if (content.pcon_iframe_url) {
      metaNavItems.push({
        title: t('product_page.pcon_ui_tool_block.nav_title'),
        url: '#pcon',
      })
    }
    if (content.uploads && content.uploads.has_downloads) {
      metaNavItems.push({
        title: t('product_page.downloads_block.nav_title'),
        url: '#downloads',
      })
    }
  }
  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} name={name} og_locale={locale} />
        <HeroBlock
          block={{
            hero_mirrored: content.hero_mirrored,
            headline: name,
            image: content.main_image,
            hero_variant_class: 'kn-product-hero',
            meta_nav_items: metaNavItems,
            video_url: content.video_url,
          }}
        />
        <ProductIntroBlock
          block={{
            product_image_hidden: content.product_image_hidden,
            image: content.isolated_image,
            alt: content.isolated_image_alt,
            name: name,
            headline: content.headline,
            intro: content.intro,
            highlight_text: content.highlight_text,
            main_text: content.main_text,
            main_award: content.uploads?.main_award,
            awards: content.uploads?.awards,
            hero_mirrored: content.hero_mirrored,
          }}
        />
        <BodyBlocks body={content.body} />

        {content.pcon_iframe_url?.length > 0 && (
          <>
            <span id="pcon"></span>
            <PconUiToolBlock
              block={{
                headline: t('product_page.pcon_ui_tool_block.title'),
                description: t('product_page.pcon_ui_tool_block.description'),
                pcon_ui_tool_url: content.pcon_iframe_url,
                custom_pcon_ui_tool_url: content.custom_pcon_iframe_url,
              }}
            />
          </>
        )}
        {content.uploads?.has_downloads && (
          <>
            <span id="downloads"></span>
            <DownloadsBlock
              block={{
                catalogue_kicker: name,
                catalogue_title: t(
                  'product_page.downloads_block.catalogue_title'
                ),
                catalogue_subtitle: t(
                  'product_page.downloads_block.catalogue_subtitle'
                ),
                downloads_title: t(
                  'product_page.downloads_block.downloads_title'
                ),
                certificates_title: t(
                  'product_page.downloads_block.certificates_title'
                ),
                catalog: content.uploads.catalog,
                certificates: content.uploads.certificates,
                product_downloads: content.uploads.product_downloads,
                category_hash: content.uploads.mdb_category_slug,
              }}
            />
          </>
        )}
        {content.similar_product_relations?.length > 0 && (
          <RelatedProductsBlock
            block={{
              headline: t('product_page.related_products_block.title'),
              subheadline: t('product_page.related_products_block.subtitle'),
              products: similarProducts,
            }}
          />
        )}
      </Layout>
    </div>
  )
}

export default ProductPage
